"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimezoneType = exports.BusinessLocationType = void 0;
var BusinessLocationType;
(function (BusinessLocationType) {
    BusinessLocationType["ON_LOCATION"] = "LOCAL";
    BusinessLocationType["ON_THE_GO"] = "ON_THE_GO";
    BusinessLocationType["UNDEFINED"] = "UNDEFINED";
})(BusinessLocationType = exports.BusinessLocationType || (exports.BusinessLocationType = {}));
var TimezoneType;
(function (TimezoneType) {
    TimezoneType["BUSINESS"] = "business";
    TimezoneType["CLIENT"] = "client";
})(TimezoneType = exports.TimezoneType || (exports.TimezoneType = {}));
//# sourceMappingURL=business.dto.js.map